import * as actionTypes from '../action-types'

const initialState = {
  agreement: {},
  purpose: {},
  refs: {}
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.UPDATE_AGREEMENT_FILTERS:
      return {
        ...state,
        agreement: {
          ...state.agreement,
          ...payload
        }
      }

    case actionTypes.UPDATE_PURPOSE_FILTERS:
      return {
        ...state,
        purpose: {
          ...state.purpose,
          ...payload
        }
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/redux-store/reducers/filter-reducer.js